import React from "react";
import "../About/About.css";
import Text from "../Text/Text";
import Plan from "../Plan/Plan";
import Details from "../Details/Details";
import { Helmet } from "react-helmet";
import { FaArrowDown } from "react-icons/fa";

const About = () => {
  const leftPoints = [
    "4 Side open Ultra Luxury Apartment in Greater Noida West",
    "Spacious and well-designed 3.5, 4.5 & 4.5XL BHK residences in an ultra-luxury development.",
    "Low-density project with double-height entrance lobbies, maximizing space and natural light.",
    "High-end finishes with modular kitchen, wardrobes, and Italian marble flooring in living and dining areas.",
    "Secured gated community with 24/7 security and CCTV surveillance.",
    "Located next to the proposed metro station and close to the upcoming Noida International Airport.",
  ];

  const rightPoints = [
    "Amenities include a well-equipped clubhouse, swimming pool, and fitness center.",
    "Sports facilities: tennis courts, badminton courts, and jogging tracks.",
    "Eco-friendly living with landscaped gardens and sustainable practices like rainwater harvesting.",
    "Proximity to schools, hospitals, shopping malls, and entertainment hubs.",
    "Children's play area with safe and engaging play zones.",
    "Strategic location with excellent connectivity to Sector-52 Metro Station and key areas of Noida.",
  ];

  return (
    <>
      <Helmet>
        {/* ----------------------------------------------------
      BASIC SEO TAGS
  ---------------------------------------------------- */}
        <title>
          About ACE Hanei Sector 12 | Ultra Luxury 4 Side Open Apartments in
          Noida Extension
        </title>
        <meta
          name="description"
          content="Discover ACE Hanei Sector 12 Noida Extension - Ultra luxury 3.5, 4.5 & 4.5XL BHK apartments with 4 side open views, double-height lobbies, modular kitchens, and premium amenities. Low-density gated community with 24/7 security."
        />
        <meta
          name="keywords"
          content="about ACE Hanei, ACE Hanei about us, ACE Hanei Sector 12 details, 4 side open apartments Noida Extension, ultra luxury apartments Greater Noida West, ACE Group about, ACE Hanei amenities, ACE Hanei location, ACE Hanei project overview, luxury living Noida Extension"
        />
        <link rel="canonical" href="https://acegroupsales.com/about" />
        <meta name="robots" content="index, follow" />
        <meta name="theme-color" content="#ffffff" />

        {/* ----------------------------------------------------
      OPEN GRAPH TAGS
  ---------------------------------------------------- */}
        <meta
          property="og:title"
          content="About ACE Hanei - Ultra Luxury 4 Side Open Apartments in Sector 12 Noida Extension"
        />
        <meta
          property="og:description"
          content="Learn about ACE Hanei Sector 12 - Ultra luxury 3.5, 4.5 & 4.5XL BHK residences with 4 side open views, double-height lobbies, and premium finishes. Gated community with world-class amenities."
        />
        <meta
          property="og:image"
          content="https://acegroupsales.com/poster.webp"
        />
        <meta property="og:url" content="https://acegroupsales.com/about" />
        <meta property="og:type" content="website" />

        {/* ----------------------------------------------------
      TWITTER META TAGS
  ---------------------------------------------------- */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="About ACE Hanei - Ultra Luxury Apartments in Noida Extension"
        />
        <meta
          name="twitter:description"
          content="ACE Hanei Sector 12 offers 4 side open ultra luxury apartments with premium amenities and excellent connectivity in Noida Extension."
        />
        <meta
          name="twitter:image"
          content="https://acegroupsales.com/poster.webp"
        />

        {/* ----------------------------------------------------
      JSON-LD SCHEMA
  ---------------------------------------------------- */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@graph": [
                {
                  "@type": "WebPage",
                  "@id": "https://acegroupsales.com/about/#webpage",
                  url: "https://acegroupsales.com/about",
                  name: "About ACE Hanei Sector 12 Noida Extension",
                  description:
                    "Learn about ACE Hanei Sector 12 - Ultra luxury 3.5, 4.5 & 4.5XL BHK apartments with 4 side open views, double-height lobbies, and premium amenities in Noida Extension.",
                  isPartOf: {
                    "@id": "https://acegroupsales.com/#website",
                  },
                  about: {
                    "@id": "https://acegroupsales.com/#ace-hanei",
                  },
                  primaryImageOfPage: {
                    "@type": "ImageObject",
                    url: "https://acegroupsales.com/poster.webp",
                  },
                  breadcrumb: {
                    "@id": "https://acegroupsales.com/about/#breadcrumb",
                  },
                  datePublished: "2024-01-01T00:00:00+05:30",
                  dateModified: "2024-12-01T00:00:00+05:30",
                },
                {
                  "@type": "BreadcrumbList",
                  "@id": "https://acegroupsales.com/about/#breadcrumb",
                  itemListElement: [
                    {
                      "@type": "ListItem",
                      position: 1,
                      name: "Home",
                      item: "https://acegroupsales.com/",
                    },
                    {
                      "@type": "ListItem",
                      position: 2,
                      name: "About",
                      item: "https://acegroupsales.com/about",
                    },
                  ],
                },
                {
                  "@type": "RealEstateListing",
                  "@id": "https://acegroupsales.com/about/#listing",
                  name: "ACE Hanei Sector 12 - About the Project",
                  description:
                    "ACE Hanei Sector 12 Noida Extension offers 4 side open ultra luxury apartments in a low-density gated community. Featuring 3.5, 4.5 & 4.5XL BHK residences with double-height entrance lobbies, modular kitchens, wardrobes, Italian marble flooring, and 24/7 security with CCTV surveillance.",
                  url: "https://acegroupsales.com/about",
                  image: [
                    "https://acegroupsales.com/poster.webp",
                    "https://acegroupsales.com/a1.webp",
                    "https://acegroupsales.com/a3.webp",
                  ],
                  address: {
                    "@type": "PostalAddress",
                    streetAddress: "Sector 12",
                    addressLocality: "Noida Extension, Greater Noida West",
                    addressRegion: "Uttar Pradesh",
                    postalCode: "201308",
                    addressCountry: "IN",
                  },
                  geo: {
                    "@type": "GeoCoordinates",
                    latitude: "28.4744",
                    longitude: "77.5040",
                  },
                  numberOfRooms: "3.5, 4.5, 4.5XL BHK",
                  floorSize: {
                    "@type": "QuantitativeValue",
                    value: "2290,3200,4190",
                    unitCode: "FTK",
                  },
                  petsAllowed: true,
                  amenityFeature: [
                    {
                      "@type": "LocationFeatureSpecification",
                      name: "4 Side Open Ultra Luxury Apartments",
                    },
                    {
                      "@type": "LocationFeatureSpecification",
                      name: "Double-Height Entrance Lobbies",
                    },
                    {
                      "@type": "LocationFeatureSpecification",
                      name: "Low-Density Project",
                    },
                    {
                      "@type": "LocationFeatureSpecification",
                      name: "Modular Kitchen",
                    },
                    {
                      "@type": "LocationFeatureSpecification",
                      name: "Premium Wardrobes",
                    },
                    {
                      "@type": "LocationFeatureSpecification",
                      name: "Italian Marble Flooring",
                    },
                    {
                      "@type": "LocationFeatureSpecification",
                      name: "24/7 Security",
                    },
                    {
                      "@type": "LocationFeatureSpecification",
                      name: "CCTV Surveillance",
                    },
                    {
                      "@type": "LocationFeatureSpecification",
                      name: "Gated Community",
                    },
                    {
                      "@type": "LocationFeatureSpecification",
                      name: "Clubhouse",
                    },
                    {
                      "@type": "LocationFeatureSpecification",
                      name: "Swimming Pool",
                    },
                    {
                      "@type": "LocationFeatureSpecification",
                      name: "Fitness Center",
                    },
                    {
                      "@type": "LocationFeatureSpecification",
                      name: "Tennis Courts",
                    },
                    {
                      "@type": "LocationFeatureSpecification",
                      name: "Badminton Courts",
                    },
                    {
                      "@type": "LocationFeatureSpecification",
                      name: "Jogging Tracks",
                    },
                    {
                      "@type": "LocationFeatureSpecification",
                      name: "Landscaped Gardens",
                    },
                    {
                      "@type": "LocationFeatureSpecification",
                      name: "Rainwater Harvesting",
                    },
                    {
                      "@type": "LocationFeatureSpecification",
                      name: "Children's Play Area",
                    },
                    {
                      "@type": "LocationFeatureSpecification",
                      name: "Proposed Metro Station Proximity",
                    },
                    {
                      "@type": "LocationFeatureSpecification",
                      name: "Noida International Airport Access",
                    },
                  ],
                  additionalProperty: [
                    {
                      "@type": "PropertyValue",
                      name: "RERA Number",
                      value: "UPRERAPRJ677887",
                    },
                    {
                      "@type": "PropertyValue",
                      name: "Project Type",
                      value: "Low-Density Ultra Luxury Apartments",
                    },
                    {
                      "@type": "PropertyValue",
                      name: "Architecture Style",
                      value: "Modern Contemporary",
                    },
                    {
                      "@type": "PropertyValue",
                      name: "View Type",
                      value: "4 Side Open Views",
                    },
                    {
                      "@type": "PropertyValue",
                      name: "Lobby Design",
                      value: "Double-Height Entrance Lobbies",
                    },
                    {
                      "@type": "PropertyValue",
                      name: "Community Type",
                      value: "Gated Community with 24/7 Security",
                    },
                  ],
                  containsPlace: [
                    {
                      "@type": "Apartment",
                      name: "3.5 BHK Luxury Apartment",
                      numberOfRooms: "3.5",
                      floorSize: {
                        "@type": "QuantitativeValue",
                        value: "2290",
                        unitCode: "FTK",
                      },
                      description:
                        "Spacious 3.5 BHK apartment with premium finishes",
                    },
                    {
                      "@type": "Apartment",
                      name: "4.5 BHK Luxury Apartment",
                      numberOfRooms: "4.5",
                      floorSize: {
                        "@type": "QuantitativeValue",
                        value: "3200",
                        unitCode: "FTK",
                      },
                      description:
                        "Luxurious 4.5 BHK apartment with expansive living spaces",
                    },
                    {
                      "@type": "Apartment",
                      name: "4.5XL BHK Luxury Apartment",
                      numberOfRooms: "4.5XL",
                      floorSize: {
                        "@type": "QuantitativeValue",
                        value: "4190",
                        unitCode: "FTK",
                      },
                      description:
                        "Ultra spacious 4.5XL BHK apartment for premium living",
                    },
                  ],
                },
                {
                  "@type": "Organization",
                  name: "ACE Group",
                  url: "https://acegroupsales.com/",
                  logo: "https://acegroupsales.com/1.webp",
                  description:
                    "ACE Group is a premier real estate developer creating ultra luxury residential projects like ACE Hanei in prime locations across Noida Extension.",
                  founder: "ACE Group",
                  foundingDate: "2000",
                  address: {
                    "@type": "PostalAddress",
                    addressLocality: "Noida",
                    addressRegion: "Uttar Pradesh",
                    addressCountry: "IN",
                  },
                  contactPoint: {
                    "@type": "ContactPoint",
                    telephone: "+917303734500",
                    contactType: "Customer Service",
                    areaServed: "IN",
                    availableLanguage: ["English", "Hindi"],
                  },
                  sameAs: [
                    "https://www.facebook.com/acegroup",
                    "https://twitter.com/acegroup",
                    "https://www.instagram.com/acegroup",
                  ],
                },
                {
                  "@type": "ContactPage",
                  url: "https://acegroupsales.com/about",
                  name: "About ACE Hanei - Contact for Information",
                  description:
                    "Contact us to learn more about ACE Hanei Sector 12 ultra luxury apartments, project details, amenities, and booking information.",
                  telephone: "+917303734500",
                  contactType: "Information Inquiry",
                  provider: {
                    "@type": "RealEstateAgent",
                    name: "Authorized Channel Partner - Shishir",
                    telephone: "+917303734500",
                    identifier: "UP RERA Registration No. UPRERAAGT24002",
                    address: {
                      "@type": "PostalAddress",
                      addressLocality: "Noida",
                      addressRegion: "Uttar Pradesh",
                      addressCountry: "IN",
                    },
                  },
                },
                {
                  "@type": "FAQPage",
                  mainEntity: [
                    {
                      "@type": "Question",
                      name: "What makes ACE Hanei different from other projects in Noida Extension?",
                      acceptedAnswer: {
                        "@type": "Answer",
                        text: "ACE Hanei offers 4 side open ultra luxury apartments with double-height lobbies, low-density living, premium finishes including modular kitchens and Italian marble flooring, and a strategic location near proposed metro station and Noida International Airport.",
                      },
                    },
                    {
                      "@type": "Question",
                      name: "What are the unit variants available at ACE Hanei?",
                      acceptedAnswer: {
                        "@type": "Answer",
                        text: "ACE Hanei offers 3.5 BHK (2290 sq.ft), 4.5 BHK (3200 sq.ft), and 4.5XL BHK (4190 sq.ft) luxury apartments with premium specifications and finishes.",
                      },
                    },
                    {
                      "@type": "Question",
                      name: "What security features does ACE Hanei provide?",
                      acceptedAnswer: {
                        "@type": "Answer",
                        text: "ACE Hanei is a secured gated community with 24/7 security personnel, CCTV surveillance across the premises, and controlled access points ensuring resident safety.",
                      },
                    },
                    {
                      "@type": "Question",
                      name: "What amenities are available at ACE Hanei?",
                      acceptedAnswer: {
                        "@type": "Answer",
                        text: "Amenities include clubhouse, swimming pool, fitness center, tennis courts, badminton courts, jogging tracks, children's play area, landscaped gardens, rainwater harvesting, and eco-friendly features.",
                      },
                    },
                    {
                      "@type": "Question",
                      name: "Where is ACE Hanei located?",
                      acceptedAnswer: {
                        "@type": "Answer",
                        text: "ACE Hanei is located in Sector 12, Greater Noida West (Noida Extension), strategically positioned next to the proposed metro station and close to Noida International Airport with excellent connectivity to key areas.",
                      },
                    },
                  ],
                },
              ],
            }),
          }}
        />
      </Helmet>
      <div className="poster-section2">
        <img
          src="a1.webp"
          alt="luxury-apartments-noida-extension"
          className="poster-image2"
        />
      </div>
      <div className="about-section">
        <h2 className="section-heading2">
          ACE Hanei Sector 12 Noida Extension
        </h2>
        <div className="about-content">
          {leftPoints.map((point, index) => (
            <div key={index} className="carda">
              <FaArrowDown className="iconar" />
              <p className="card-content">{point}</p>
            </div>
          ))}
          {rightPoints.map((point, index) => (
            <div key={index} className="carda">
              <FaArrowDown className="iconar" />
              <p className="card-content">{point}</p>
            </div>
          ))}
        </div>
      </div>

      <Details />
    </>
  );
};

export default About;
